import DynamicModal from 'components/DynamicModal';
import TableWithStickyHeader from 'components/TableWithStickyHeader';
import { showSuccessToast } from 'lib/ToastHelper';
import moment from 'moment';
import React from 'react';
import Select from 'react-select';
import { MagicSpinner } from 'react-spinners-kit';
import { toast, ToastContainer } from 'react-toastify';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

import ReportDetailModal from './ReportDetailModal';
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound';
import {
  colourStyles,
  slimColourStyles,
  PAGE_SIZES,
  FORMAT_TYPES,
  SourceTypeReport,
  ACTIVE_OR_FIXED_CATEGORIES,
  REPORT_CATEGORIES,
  REPORT_FILTERS,
} from '../../components/Styles/Filter';
import { verifyAccessToken } from '../../lib/auth';
import axios from '../../lib/axiosInstance';

class ReportList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      confirmDownload: false,
      currentReport: {},
      currentReportId: 0,
      company_search_data: '',
      loader: true,
      currentPage: 0,
      pageSize: 25.0,
      ordering: '-id',
      format_type: { value: '', label: 'All' },
      source_type: { value: '', label: 'All' },
      active_or_fixed: { value: '', label: 'All' },
      selectedCategoryOption: { value: '', label: 'All' },
    };
  }
  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchReports();
    }, 60);
  }
  // TODO: Refactor showSuccessToast function import from lib.
  showSuccessToast(message) {
    toast.success(message, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  componentDidMount() {
    let search = window.location.search.split('search=');
    if (search.length > 1) {
      search = window.location.search.split('search=')[1].split('&')[0];
      this.setState({ company_search_data: search });
    }
    this.showSuccessToast.bind(this);
    this.fetchReports();
    localStorage.setItem('last_path', window.location.pathname);
  }
  componentDidUpdate(prevProps, prevState) {
    // Check if the specific prop has been updated
    if (this.props.currentCompanyId !== prevProps.currentCompanyId) {
      this.updatePage();
    }
  }

  updatePage() {
    this.fetchReports();
  }

  async fetchReports(currentUrl, currentPage, company_id) {
    this.setState({ loader: true });
    if (company_id === undefined) {
      company_id = this.props.currentCompanyId;
    }
    await verifyAccessToken();
    let url =
        '/reports/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize),
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (currentUrl) {
      url = currentUrl;
    }
    url += '&report_format=' + this.state.format_type.value;
    url += '&name__contains=' + this.state.source_type.value;
    url += this.state.selectedCategoryOption.value;
    url += this.state.active_or_fixed.value;
    url += '&ordering=' + this.state.ordering;
    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }
    url += '&company_id=' + this.props.currentCompanyId;
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? '/reports/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/reports/?' + res.data.previous.split('?')[1]
                : null,
            });
          } else {
            this.setState({ reports: [], count: 0, loader: false });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  // refactored named from fetchReportsFromQualys to syncReportsFromQualys
  async syncReportsFromQualys() {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/qualys/reports/latest/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      },
      data = {};
    await axios
      .post(url, data, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loader: false });
        if (res.status === 201 || res.status === 200) {
          this.showSuccessToast(
            'The syncing process is started, which may take some time to complete. Please be patient and check back later for updates.',
          );
        } else if (res.status === 422) {
          console.error('Error: Unprocessable Entity', res);
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          console.error('Error: Unauthorized or Bad Request:', res);
        }
      });
  }

  async downlaodReport(id) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/reports/' + id + '/download/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loader: false });

        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            // let currentData = res.data
            // 1. Convert the data into 'blob'
            // .then((response) => response.blob())
            // .then((blob) => {

            // 2. Create blob link to download
            const url = res.data['signed_url'];
            // window.URL.window.URL.createObjectURL(new Blob([res.data['report_data']]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `sample.${this.state.file}`);
            // 3. Append to html page
            document.body.appendChild(link);
            // 4. Force download
            link.click();
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);

            // Close Modal and show success toast
            this.setState({ confirmDownload: false });
            showSuccessToast('Report downloaded successfully');
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }

  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() => {
              this.fetchReports(this.state.nextUrl, this.state.currentPage + 1);
            }}
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() => {
              this.fetchReports(
                this.state.previousUrl,
                this.state.currentPage - 1,
              );
            }}
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / this.state.pageSize),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      let url =
        '/reports/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize) +
        '&offset=' +
        parseInt(this.state.pageSize * index);
      pages.push(
        <PaginationItem
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchReports(url, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        let url =
          '/reports/?search=' +
          this.state.company_search_data +
          '&limit=' +
          this.state.pageSize +
          '&offset=' +
          parseInt(this.state.pageSize * pageIndex);
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink onClick={() => this.fetchReports(url, pageIndex)}>
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(
        <PaginationItem className="more-pages">
          {/* <PaginationLink > */}
          ...
          {/* </PaginationLink> */}
        </PaginationItem>,
      );
    }
    if (rightPages >= 1) {
      let url =
        '/reports/?search=' +
        this.state.company_search_data +
        '&limit=' +
        this.state.pageSize +
        '&offset=' +
        parseInt(this.state.pageSize * (pageCount - 1));
      pages.push(
        <PaginationItem
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchReports(url, pageCount - 1)}>
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / this.state.pageSize);
    if (pageCount > 1) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10">
            <Pagination aria-label="Page navigation example">
              {this.renderPreviousUrl()}
              {this.renderPages()}
              {this.renderNextUrl()}
            </Pagination>
          </Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchReports();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    } else if (this.state.count > 25) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10"></Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchReports();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    }
  }

  renderReportDetailModal() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.toggle.bind(this)}>
          <h4>Report Detail</h4>
        </ModalHeader>
        <ModalBody>
          {this.state.currentReportId > 0 && (
            <ReportDetailModal id={this.state.currentReportId} />
          )}
        </ModalBody>
        <ModalFooter>
          {' '}
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggle.bind(this)()}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  openReportDetailModal(id) {
    this.setState({
      modal: true,
      currentReportId: id,
    });
  }
  renderConfirmDownloadModal() {
    return (
      <DynamicModal
        isOpen={this.state.confirmDownload}
        toggle={() => this.setState({ confirmDownload: false })}
        title="Download"
        content={
          <div>
            <p>
              SAST reports are limited to 500 findings (i.e., bugs and
              vulnerabilities). If there are more, the alternate approach to see
              them all is to utilize the Vulnerabilities page, filter for the
              criteria of interest, and export to a CSV file.
            </p>
          </div>
        }
        size="sm"
        footerActions={
          <>
            <Button
              color="secondary"
              onClick={() => this.setState({ confirmDownload: false })}
            >
              Cancel
            </Button>
            <Button
              style={{ marginLeft: 'auto' }}
              color="primary"
              disabled={this.state.loader}
              onClick={() => {
                this.downlaodReport.bind(this)(this.state.currentReportId);
              }}
            >
              Download
            </Button>
          </>
        }
      />
    );
  }
  renderButton(data) {
    if (
      data.report_status === 'COMPLETE' ||
      data.report_status === 'Finished' ||
      data.report_status === 'Complete'
    ) {
      return (
        <>
          <Button
            color="primary"
            outline
            size="sm"
            title={'Show details'}
            onClick={() => this.openReportDetailModal.bind(this)(data.id)}
          >
            <i className="fa fa-eye"></i>
          </Button>
          {data.report_type === 'SAST' ? (
            <Button
              color="primary"
              outline
              size="sm"
              title={'Download report'}
              onClick={() =>
                this.setState({
                  confirmDownload: true,
                  currentReportId: data.id,
                })
              }
            >
              <i className="tim-icons icon-cloud-download-93"></i>
            </Button>
          ) : (
            <Button
              color="primary"
              outline
              size="sm"
              title={'Download report'}
              onClick={() => this.downlaodReport.bind(this)(data.id)}
            >
              <i className="tim-icons icon-cloud-download-93"></i>
            </Button>
          )}
        </>
      );
    } else {
      return (
        <>
          <Button
            color="primary"
            outline
            size="sm"
            title={'Show details'}
            onClick={() => this.openReportDetailModal.bind(this)(data.id)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </>
      );
    }
  }
  renderReportName(name, company) {
    let data = name.split('-');
    if (data.length > 1) {
      if (
        ['PDF', 'HTML', 'CSV'].indexOf(data[data.length - 1].toUpperCase()) >= 0
      ) {
        data.pop();
      }
      if (company.toUpperCase() === data[0].toUpperCase()) {
        data.shift();
      }
    }
    return data.join(' ');
  }

  renderReportList() {
    let reports = this.state.reports;
    return (
      <>
        {reports.map((data, idx) => {
          let status = data.report_status;
          return (
            <tr key={idx} className="report-list-row">
              <td className="">{data.report_id}</td>
              <td className="">
                {this.renderReportName(data.name, data.company)}
              </td>
              <td className="">
                {data.report_format === 'HTML_BASE64'
                  ? 'HTML'
                  : data.report_format}
              </td>
              <td className="">
                {status.toLowerCase() === 'finished' ||
                status.toLowerCase() === 'complete'
                  ? 'Complete'
                  : status}
              </td>
              <td className="">
                {data.report_creation_date.length > 0
                  ? moment(data.report_creation_date).format('lll')
                  : ''}
              </td>
              <td className="">{data.archieved === true ? 'Yes' : 'No'}</td>
              <td className="text-right">
                {this.renderButton.bind(this)(data)}
              </td>
            </tr>
          );
        })}
      </>
    );
  }
  // TODO: Commented getOwner because we are not receiving owner's first and last name in the Qualys API response
  // getOwner(owner){
  //     if(owner && owner.firstName){
  //         return owner.firstName + " " + owner.lastName
  //     }
  // }

  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  render() {
    let { companies, source_type, format_type, selectedCategoryOption } =
      this.state;
    let sourceTypeReport = SourceTypeReport;
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col xl="4" md="4" sm="12">
                      <h4>
                        Reports{' '}
                        <label className="label btn">{this.state.count}</label>
                      </h4>
                    </Col>
                    <Col xl="12" md="12" sm="12" className="text-right">
                      <Row>
                        <Col
                          md="2"
                          sm="12"
                          className="text-left md-no-padding md-sp-padding"
                        >
                          <Label>Host Type</Label>
                          <Select
                            className="custom-360-dropdown"
                            value={source_type}
                            onChange={(e) => {
                              this.setState({
                                source_type: e,
                                // conditionally reset the format_type
                                // if the source_type is 'Compliance Report'
                                format_type:
                                  e.value === 'Compliance Report'
                                    ? { value: '', label: 'All' }
                                    : this.state.format_type,
                                // conditionally reset the selectedCategoryOption
                                // if the source_type is 'Compliance Report'
                                selectedCategoryOption:
                                  e.value === 'Compliance Report'
                                    ? { value: '', label: 'All' }
                                    : this.state.selectedCategoryOption,
                              });
                              let self = this;
                              setTimeout(function () {
                                self.fetchReports();
                              }, 100);
                            }}
                            styles={colourStyles}
                            options={sourceTypeReport}
                          />
                        </Col>
                        <Col
                          md="2"
                          sm="12"
                          className="text-left md-sp-padding"
                          style={{ minWidth: '' }}
                        >
                          <Label>Format</Label>
                          <Select
                            className="custom-360-dropdown"
                            value={format_type}
                            onChange={(e) => {
                              this.setState({
                                format_type: e,
                              });
                              let self = this;
                              setTimeout(function () {
                                self.fetchReports();
                              }, 100);
                            }}
                            styles={colourStyles}
                            isDisabled={
                              this.state.source_type.value ===
                              'Compliance Report'
                                ? true
                                : false
                            }
                            options={FORMAT_TYPES}
                          />
                        </Col>
                        <Col
                          md="2"
                          sm="12"
                          className="text-left small-screen-no-padding md-sp-padding"
                          style={{ minWidth: '' }}
                        >
                          <Label>Predefined Filters</Label>
                          <Select
                            className="custom-360-dropdown"
                            value={selectedCategoryOption}
                            onChange={(e) => {
                              this.setState({ selectedCategoryOption: e });
                              let self = this;
                              setTimeout(function () {
                                self.fetchReports();
                              }, 100);
                            }}
                            styles={colourStyles}
                            isDisabled={
                              this.state.source_type.value === 'SAST' ||
                              this.state.source_type.value ===
                                'Compliance Report'
                                ? true
                                : false
                            }
                            options={
                              this.state.source_type.value === ''
                                ? REPORT_FILTERS
                                : this.state.source_type.value === '-WAS-'
                                  ? ACTIVE_OR_FIXED_CATEGORIES
                                  : REPORT_CATEGORIES
                            }
                          />
                        </Col>
                        <Col
                          md="3"
                          sm="12"
                          className="text-left md-no-padding md-sp-padding"
                          style={{ minWidth: '' }}
                        >
                          <Label>Search</Label>
                          <Input
                            type="text"
                            list="data"
                            value={this.state.company_search_data}
                            placeholder="Search Report"
                            onChange={(e) => {
                              this.setState({
                                company_search_data: e.target.value,
                              });
                              this.fetchReports();
                            }}
                          />
                        </Col>
                        <Col md="1" sm="12" className="text-right" style={{}}>
                          <Button
                            color="primary"
                            size="sm"
                            style={{ marginTop: '18px' }}
                            onClick={() =>
                              this.syncReportsFromQualys.bind(this)()
                            }
                          >
                            <i className="tim-icons icon-refresh-02"></i>
                            <span
                              style={{
                                fontSize: '10px',
                                fontWeight: 'normal',
                                paddingTop: '2px',
                              }}
                            >
                              Sync with Qualys
                            </span>
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.reports.length === 0 && <NoRecordFound />}
                {this.state.reports.length !== 0 && (
                  <CardBody>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead" style={{ cursor: 'pointer' }}>
                          <th
                            onClick={() => {
                              this.orderBy('report_id');
                            }}
                          >
                            ID
                            <i
                              className={
                                this.state.ordering === 'report_id'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-report_id'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('name');
                            }}
                          >
                            Name
                            <i
                              className={
                                this.state.ordering === 'name'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-name'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('report_format');
                            }}
                          >
                            Format
                            <i
                              className={
                                this.state.ordering === 'report_format'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-report_format'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('report_status');
                            }}
                          >
                            Status
                            <i
                              className={
                                this.state.ordering === 'report_status'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-report_status'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('report_creation_date');
                            }}
                          >
                            Creation Date
                            <i
                              className={
                                this.state.ordering === 'report_creation_date'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering ===
                                      '-report_creation_date'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('archieved');
                            }}
                          >
                            Archived
                            <i
                              className={
                                this.state.ordering === 'archieved'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-archieved'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th className="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </TableWithStickyHeader>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderReportDetailModal()}
        {this.state.confirmDownload && this.renderConfirmDownloadModal()}
        {this.renderLoader()}
        <ToastContainer />
      </>
    );
  }
}

export { ReportList };
